<template>
  <div class="hello">
    <div class="navbar-wrapper">
      <div class="container">
        <nav
          class="navbar navbar-inverse navbar-static-top"
          style="display: flex; flex-wrap: nowrap"
        >
          <div class="navbar-header" style="margin-left: 15px">
            <div class="pad-10">
              <img
                src="@/assets/image/logo.png"
                alt="logo"
                style="height: 36px"
              />
            </div>
          </div>
          <div id="navbar" class="navbar-collapse">
            <ul class="nav">
              <li class="nav-li nav-active">
                <a href="/index/index.action" class="scroll">首页</a>
              </li>
              <li class="nav-li">
                <a href="#contact" class="scroll">咨询中心</a>
              </li>
              <li class="nav-li">
                <a href="#assist" class="scroll">援助热线</a>
              </li>
              <li class="nav-li nav-li-sec">
                <a
                  href="/contentMana/contentList.action?ccID=78"
                  target="_blank"
                  class="scroll"
                  >教育宣传</a
                >
                <ul class="nav-sec-li">
                  <li>
                    <a
                      href="/contentMana/contentList.action?ccID=78"
                      target="_blank"
                      >精神卫生动态</a
                    >
                  </li>
                  <li>
                    <a
                      href="/contentMana/contentList.action?ccID=79"
                      target="_blank"
                      >精神康复知识</a
                    >
                  </li>
                  <li>
                    <a
                      href="/contentMana/contentList.action?ccID=80"
                      target="_blank"
                      >心理健康知识</a
                    >
                  </li>
                  <li>
                    <a
                      href="/contentMana/contentList.action?ccID=77"
                      target="_blank"
                      >&nbsp;&nbsp;&nbsp;&nbsp;宣教视频</a
                    >
                  </li>
                </ul>
              </li>
              <li class="nav-li">
                <a href="#about" class="scroll">关于云平台</a>
              </li>
              <li class="nav-li">
                <a href="http://www.hnjsws.cn/app/appdown.html" class="scroll"
                  >下载专区</a
                >
              </li>
            </ul>
          </div>
        </nav>
      </div>
    </div>
    <!-- 轮播图 -->
    <div
      id="myCarousel"
      class="carousel slide carousel-fade"
      data-ride="carousel"
      data-interval="5000"
    >
      <ol class="carousel-indicators">
        <li data-target="#carousel" data-slide-to="0" class="active"></li>
        <li data-target="#carousel" data-slide-to="1"></li>
      </ol>
      <!-- 登录入口 -->
      <div class="container">
        <div class="row">
          <div class="carousel-caption">
            <h1 class="hidden-xs" style="font-size: 56px; line-height: 80px">
              国内专业心理服务平台
            </h1>
            <p style="font-size: 20px; line-height: 36px">
              严选TOP1%心理咨询师，提供高质量心理服务
            </p>
          </div>
        </div>
      </div>
      <div class="carousel-inner" role="listbox">
        <div class="item active">
          <img
            class="first-slide"
            src="@/assets/image/1.jpg"
            alt="First slide"
          />
        </div>
        <div class="item">
          <img
            class="second-slide"
            src="@/assets/image/2.jpg"
            alt="Second slide"
          />
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div
          style="
            width: 100%;
            display: inline-flex;
            justify-content: space-around;
            margin-top: 20px;
          "
        >
          <div class="hidden-xs btn-group">
            <a
              href="http://xlypt-dr.hnjsws.cn/index.action"
              target="_blank"
              type="button"
              class="btn btn-default"
              style="
                background-color: #1e6734;
                border: #1e6734;
                color: #fff;
                padding: 12px 24px;
              "
              >医生/咨询师登录</a
            >
          </div>
          <!--  <div class="hidden-xs btn-group">
          <a href="http://xlypt.hnjsws.cn/login/userNameLogin.action" target="_blank" type="button" class="btn btn-default" style="background-color: #1e6734;border: #1e6734;color: #fff;padding: 12px 24px">我是个人用户</a>
        </div> -->
          <div class="hidden-xs btn-group">
            <a
              href="http://xlypt-video.hnjsws.cn:8090"
              target="_blank"
              type="button"
              class="btn btn-default"
              style="
                background-color: #1e6734;
                border: #1e6734;
                color: #fff;
                padding: 12px 24px;
              "
              >随访系统登录</a
            >
          </div>
          <div class="hidden-xs btn-group">
            <a
              href="http://xlypt-dr.hnjsws.cn/index.action"
              target="_blank"
              type="button"
              class="btn btn-default"
              style="
                background-color: #1e6734;
                border: #1e6734;
                心理援助热线：0373-7095888color: #fff;
                padding: 12px 24px;
                color: white;
              "
              >满意度调查</a
            >
          </div>
          <div class="hidden-xs btn-group">
            <a
              href="#code"
              class="btn btn-default"
              style="
                background-color: #1e6734;
                border: #1e6734;
                color: #fff;
                padding: 12px 24px;
              "
              >培训APP下载</a
            >
          </div>
          <!-- <div class="hidden-xs btn-group">
						<a type="button" href="http://www.hnjsws.cn:7010/static/pc/login.html" class="btn btn-default"
							style="background-color: #1e6734;border: #1e6734;color: #fff;padding: 12px 24px">质控上报</a>
					</div> -->
          <div class="hidden-xs btn-group">
            <a
              type="button"
              href="http://xlypt-dr.hnjsws.cn/index.action"
              target="_blank"
              class="btn btn-default"
              style="
                background-color: #1e6734;
                border: #1e6734;
                color: #fff;
                padding: 12px 24px;
              "
              >质控上报</a
            >
          </div>
          <div class="hidden-xs btn-group">
            <a
              type="button"
			  href="#vbtdiv"
              class="btn btn-default"
              style="
                background-color: #1e6734;
                border: #1e6734;
                color: #fff;
                padding: 12px 24px;
              "
              >VBT-VR心理治疗</a
            >
			<!-- target="_blank" -->
			<!-- href="http://www.hnjsws.cn/VBT.jsp" -->
			
          </div>
        </div>
      </div>
    </div>
    <div style="background-color: #ffffff" id="contact">
      <div class="container">
        <h2 class="text-center" style="margin: 60px 0 40px 0">
          河南省心理咨询中心简介
        </h2>
        <p class="lead" style="text-align: justify">
          河南省心理咨询中心依托于河南省精神病医院（新乡医学院第二附属医院、河南省精神卫生中心），成立于1999年，是河南省最专业的心理评估与咨询机构。中心拥有国内先进的心理评估工具，面向各年龄段、社会各阶层人员进行心理健康状况评估。开展心理咨询与多种形式的心理治疗（认知行为治疗、精神分析治疗、家庭治疗、团体治疗等）。在教学方面，我中心拥有用于实践技能培训的心理咨询示教室和行为观察室，接受全国专业人员的进修和本科生、研究生、住培生的实习。
        </p>
        <p class="lead" style="text-align: justify; margin: 0 0 80px 0">
          我中心负责管理河南省心理危机干预中心，该中心下设心理援助热线部、干预救援部、培训部和研究部4个部门，以向群众提供免费电话心理咨询、心理健康教育、心理救援、心理危机干预、研究及人员培训为基本导向。河南省心理援助热线（0373-7095888）以电话、微信形式24小时免费为公众提供专业的心理援助、心理支持和危机干预。我中心有河南省重点学科“应用心理学”，是河南省心理卫生协会的挂靠单位，担任着全省心理卫生的管理和促进工作。
        </p>
      </div>
    </div>
    <!-- 专家介绍 -->
    <div style="background: #ececec">
      <div class="container">
        <h2 class="text-center" style="margin: 50px 0 40px 0">专家简介</h2>
        <a
          href="/contentMana/contentList.action?ccID=74"
          target="_blank"
          style="
            width: 98%;
            display: inline-flex;
            justify-content: flex-end;
            color: #333;
            cursor: pointer;
          "
          >了解更多></a
        >
        <div class="row featurette" style="margin: 20px 0 80px">
          <div class="col-md-3 col-sm-4 col-xs-12">
            <div class="expert">
              <img
                src="http://47.92.208.80:8010/attachment//info/2021/04/19/NEWS210419151738431.jpg"
                class="pic"
              />
              <p class="name">宋景贵</p>
              <p class="introduce">
                宋景贵，教授、主任医师、医学博士、博士研究生导师、新乡医学院第二附属医院党委书记。从事神经...
              </p>
              <a
                href="/contentMana/contentDetail.action?contentID=2120"
                target="_blank"
                >了解更多></a
              >
            </div>
          </div>

          <div class="col-md-3 col-sm-4 col-xs-12">
            <div class="expert">
              <img
                src="http://47.92.208.80:8010/attachment//info/2021/04/19/NEWS210419151921420.jpg"
                class="pic"
              />
              <p class="name">王长虹</p>
              <p class="introduce">
                主任医师、国家二级教授，医学博士，硕士生导师。享受国务院特殊津贴，中国心理卫生协会专家库资...
              </p>
              <a
                href="/contentMana/contentDetail.action?contentID=2121"
                target="_blank"
                >了解更多></a
              >
            </div>
          </div>

          <div class="col-md-3 col-sm-4 col-xs-12">
            <div class="expert">
              <img
                src="http://47.92.208.80:8010/attachment//info/2019/03/19/NEWS190319120037867.png"
                class="pic"
              />
              <p class="name">张瑞岭</p>
              <p class="introduce">
                主任医师、教授，医学博士，博士生导师，河南省优秀医师及卫生科技领军人才，国务院特殊津贴专家...
              </p>
              <a
                href="/contentMana/contentDetail.action?contentID=2122"
                target="_blank"
                >了解更多></a
              >
            </div>
          </div>

          <div class="col-md-3 col-sm-4 col-xs-12">
            <div class="expert">
              <img
                src="http://47.92.208.80:8010/attachment//info/2021/04/19/NEWS210419152155474.jpg"
                class="pic"
              />
              <p class="name">李玉凤</p>
              <p class="introduce">
                主任医师，硕士生导师。中华医学会司法鉴定学组委员、中国医师协会伦理与法律专委会委员，发表学...
              </p>
              <a href="#" target="_blank">了解更多></a>
              <!-- /contentMana/contentDetail.action?contentID=2123 -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      style="background-color: #1e6734; height: 260px; margin: -260px 0 0 0"
    ></div>

    <div class="container" id="assist">
      <h2 class="text-center" style="margin: 100px 0 40px 0">
        河南省心理援助热线介绍
      </h2>
      <p class="lead" style="text-align: justify; margin: 0 0 80px 0">
        1995年，河南省精神卫生中心几位年轻医生利用业余时间，不计报酬，率先在我国开通了第一条免费心理咨询热线0373-7095888。这份无私，已默默奉献了20多个年头，在这20余年的时间里，共接听全国来电56000个，其中有高危自杀倾向的来电5000个之多，报复社会心理的来电也有2000余个，因为极具专业性的心理疏导，5000多个鲜活的生命得以挽救，社会和谐与稳定得以维护。这条免费的公益心理援助服务热线所作出的贡献，不但得到了社会的认可，更在2008年成为国家卫计委首批17条心理援助热线之一，2013年开始挂靠于河南省心理咨询中心。2015年在省委、省政府的大力支持下，以国家示范型标准建成新的热线咨询信息系统平台，面向全国提供每周7天、每天24小时的免费咨询服务。
      </p>
    </div>
    <!-- 动态数据显示 -->
    <div style="background-color: #f8f8f8">
      <div class="container mar-20">
        <ul class="row list-unstyled">
          <li class="col-xs-6 col-sm-6 col-md-3 col-lg-3">
            <div class="text-center figure nine" data-val="383"></div>
            <p class="text-center">平台覆盖用户</p>
          </li>
          <li class="col-xs-6 col-sm-6 col-md-3 col-lg-3">
            <div class="text-center figure nine" data-val="352"></div>
            <p class="text-center">实时监测用户</p>
          </li>
          <li class="col-xs-6 col-sm-6 col-md-3 col-lg-3">
            <div class="text-center figure nine" data-val="215"></div>
            <p class="text-center">平台合作机构</p>
          </li>
          <li class="col-xs-6 col-sm-6 col-md-3 col-lg-3">
            <div class="text-center figure nine" data-val="261"></div>
            <p class="text-center">主任级医师</p>
          </li>
        </ul>
      </div>
    </div>
    <!-- 蓝色区域、左字右图 -->
    <div class="bg-blue">
      <div class="container">
        <div class="row featurette">
          <div class="col-md-6" style="margin: 42px 0">
            <h2 class="text-center" style="margin: 0 0 20px 0; color: #eaf1f7">
              心理健康云服务
            </h2>
            <p class="lead" style="color: #d7ebfc; text-align: justify">
              基于云计算，构建未来数字化心理平台，运用大数据，提供心理健康个性化解决方案，提供了心理测评、危机预警、心理档案、微信测评和咨询、心理训练、心理门户等众多功能。能帮助医疗机构、教育机构、社区等开展规范化的心理健康服务、教育宣传工作。云平台向公众提供24小时免费电话心理咨询与危机干预；基于网络、微信平台，面向各年龄段、社会各阶层人员进行心理健康状况评估；预约开展心理咨询与多种形式的心理治疗（认知行为治疗、精神分析治疗、家庭治疗、正念减压、沙盘游戏、团体治疗等）；对社会各类人群的心理健康教育；对心理健康服务工作者的培训督导；建立河南省心理救援网络平台，参与省内外突发事件的心理危机干预，对经历心理危机的个人、群体提供心理援助服务；大数据管理，对采集的数据进行整合、处理分析、提取、统计。
            </p>
          </div>
          <div class="col-md-6" style="padding: 0 40px">
            <img
              class="featurette-image img-responsive center-block img-blue"
              src="@/assets/image/7.jpg"
              alt="河南省精神卫生中心"
            />
          </div>
        </div>
      </div>
    </div>
    <div style="background-color: #f8f8f8" id="about">
      <div class="container">
        <h2 class="text-center" style="margin: 100px 0 40px 0">
          关于心理健康云平台
        </h2>
        <p class="lead" style="text-align: justify; margin: 0 0 80px 0">
          心理援助云平台致力于打造国人的身心健康服务生态圈，布局“身心健康+互联网”，以身心健康服务与管理为核心战略，线上线下医疗联合体为基石，深度融合大数据、人工智能、物联网、云服务等技术，链接心理领域医疗资源，构建智慧身心健康联盟生态。心理援助云平台是由河南省精神卫生中心指导省级心理健康产业服务平台，向机构和公众提供身心健康管理工具、产品及服务
        </p>
      </div>
    </div>
	<div class="bg-blue" id="vbtdiv">
	  <div class="container">
	    <div class="row featurette">
	      <div class="col-md-6" style="margin: 42px 0">
	        <h2 class="text-center" style="margin: 0 0 20px 0; color: #eaf1f7">
	          VBT-VR心理治疗
	        </h2>
	        <p class="lead" style="color: #d7ebfc; text-align: justify">
	          VBT-VR短程心理治疗与评估系统
	             VBT-VR心理治疗与评估系统是以价值取向短程心理治疗（value orientation brief therapy，VBT）为理论基础，借助VR形式，让用户身临其境，主动应对焦虑、强迫等心理障碍，放松身心，培育良好的心态。
	          涵括预约、评估、预警、咨询、认知—应对心理训练、档案、随访、健康讲座、数据分析、大数据中心等多个心理模块一体化的心理治疗及心理服务云平台。
	        </p>
	      </div>
	      <div class="col-md-6" style="padding: 0 40px">
	        <img
	          class="featurette-image img-responsive center-block img-blue"
			  style="margin: 8rem 0;"
	          src="@/assets/image/vbt-vr.png"
	          alt="河南省精神卫生中心"
	        />
	      </div>
	    </div>
	  </div>
	</div>
    <!-- 底部四个模块 -->
    <div class="bg-wri">
      <div class="container mar-20">
        <ul class="row list-unstyled" style="margin: 30px 0 10px 0">
          <li class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
            <div class="img-top">
              <img
                src="@/assets/image/7.png"
                class="img-responsive center-block"
              />
              <h1 class="text-center" style="margin-bottom: 0">
                <small>心理测评</small>
              </h1>
            </div>
            <div class="img-wri">
              <h3 class="text-center" style="margin-top: 0">心理测评</h3>
              <p class="text-center text-over">
                基于移动互联网的云端心理测评平台
              </p>
            </div>
            <div class="text-center img-bott">
              <p style="margin: 0">云端测评</p>
              <p style="margin: 0">安全便捷</p>
              <p style="margin: 0">实时准确</p>
            </div>
          </li>
          <li class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
            <div class="img-top">
              <img
                src="@/assets/image/8.png"
                class="img-responsive center-block"
              />
              <h1 class="text-center" style="margin-bottom: 0">
                <small>心理咨询</small>
              </h1>
            </div>
            <div class="img-wri">
              <h3 class="text-center" style="margin-top: 0">心理咨询</h3>
              <p class="text-center">基于微信端的心理在线心理援助咨询平台</p>
            </div>
            <div class="text-center img-bott">
              <p style="margin: 0">高效专业</p>
              <p style="margin: 0">信效度高</p>
              <p style="margin: 0">方式灵活</p>
            </div>
          </li>
          <li class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
            <div class="img-top">
              <img
                src="@/assets/image/9.png"
                class="img-responsive center-block"
              />
              <h1 class="text-center" style="margin-bottom: 0">
                <small>心理干预</small>
              </h1>
            </div>
            <div class="img-wri">
              <h3 class="text-center" style="margin-top: 0">心理干预</h3>
              <p class="text-center">
                云端心理干预训练，通过微信端可方便在线浏览图文内容及音频视频
              </p>
            </div>
            <div class="text-center img-bott">
              <p style="margin: 0">内容专业</p>
              <p style="margin: 0">使用便捷</p>
              <p style="margin: 0">针对性强</p>
            </div>
          </li>
          <li class="col-xs-12 col-sm-12 col-md-6 col-lg-3">
            <div class="img-top">
              <img
                src="@/assets/image/10.png"
                class="img-responsive center-block"
              />
              <h1 class="text-center" style="margin-bottom: 0">
                <small>教育宣传</small>
              </h1>
            </div>
            <div class="img-wri">
              <h3 class="text-center" style="margin-top: 0">教育宣传</h3>
              <p class="text-center">
                机构+平台的服务模式可以更大面的服务于广大群众
              </p>
            </div>
            <div class="text-center img-bott">
              <p style="margin: 0">更新迅速</p>
              <p style="margin: 0">传播广泛</p>
              <p style="margin: 0">精准推送</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- FOOTER -->
    <footer class="footer">
      <div class="container">
        <div class="visible-lg col-lg-2">
          <img src="@/assets/image/code.jpg" class="center-block" />
          <p class="text-center" style="line-height: 30px; color: #aaa">
            官方微信二维码
          </p>
        </div>
        <div class="visible-lg col-lg-4">
          <img src="@/assets/image/logo_foot.png" />
          <p style="color: #aaa; margin: 30px 10px 0">
            河南省精神病医院是一所享誉全国的大型公立精神卫生专科医院，是集医疗、教学、科研、预防、康复、保健、司法精神医学鉴定为一体的省级精神、神经疾病专科三级甲等医院。
          </p>
        </div>
        <div class="visible-lg col-lg-4">
          <h4 style="color: #aaa">联系我们</h4>
          <span style="color: #aaa">
            地址：河南省新乡市牧野区建设路388号<br />邮编：453002<br />邮箱：ybof2fy@126.com
            <br />咨询电话：0373-3373990/0373-3373894<br />投诉电话：0373-3373996<br />心理援助热线：0373-7095888</span
          >
        </div>
        <div class="col-sm-12 col-lg-2" id="code">
          <img src="@/assets/image/appCode.jpg" class="center-block" />
          <p class="text-center" style="line-height: 30px; color: #aaa">
            心理培训APP下载
          </p>
        </div>
      </div>
    </footer>
    <div>
      <div class="container text-center">
        新乡医学院第二附属医院（河南省精神病医院）版权所有
        <a href="http://beian.miit.gov.cn">豫ICP备14022975号</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String,
  },
  beforeCreate() {
    document.title = "河南省精神卫生中心";
  },
};
</script>

<style>
body {
  padding-bottom: 40px;
  color: #5a5a5a;
}

.navbar-wrapper {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 9999;
}

/* Flip around the padding for proper display in narrow viewports */
.navbar-wrapper > .container {
  padding-right: 0;
  padding-left: 0;
}
.navbar-wrapper .navbar {
  padding-right: 15px;
  padding-left: 15px;
}

/* CUSTOMIZE THE CAROUSEL
-------------------------------------------------- */

/* Carousel base class */
.carousel {
  height: 640px;
}
/* Since positioning the image, we need to help out the caption */
.carousel-caption {
  z-index: 10;
  /* width: 100%; */
  left: 0% !important;
}

/* Declare heights because of positioning of img element */
.carousel .item {
  height: 640px;
}
.carousel-inner > .item > img {
  position: absolute;
  top: 0;
  left: 0;
  min-width: 100%;
  height: 640px;
  object-fit: cover;
  overflow: hidden;
}

/* MARKETING CONTENT
-------------------------------------------------- */

/* Center align the text within the three columns below the carousel */
.marketing .col-lg-4 {
  margin-bottom: 20px;
  text-align: center;
}
.marketing h2 {
  font-weight: normal;
}
.marketing .col-lg-4 p {
  margin-right: 10px;
  margin-left: 10px;
}

/* Featurettes
------------------------- */

.featurette-divider {
  margin: 40px 0; /* Space out the Bootstrap <hr> more */
}

/* Thin out the marketing headings */
.featurette-heading {
  font-weight: 300;
  line-height: 1;
  letter-spacing: -1px;
}

/* RESPONSIVE CSS
-------------------------------------------------- */

@media (min-width: 768px) {
  /* Navbar positioning foo */
  .navbar-wrapper {
    margin-top: 20px;
  }
  .navbar-wrapper .container {
    padding-right: 15px;
    padding-left: 15px;
  }
  .navbar-wrapper .navbar {
    padding-right: 0;
    padding-left: 0;
  }

  /* The navbar becomes detached from the top, so we round the corners */
  .navbar-wrapper .navbar {
    border-radius: 4px;
  }

  /* Bump up size of carousel content */
  .carousel-caption p {
    margin-bottom: 30px;
    font-size: 21px;
    line-height: 1.4;
  }

  .featurette-heading {
    font-size: 50px;
  }
}
.navbar-nav {
  flex-direction: row;
}

@media (min-width: 992px) {
  .featurette-heading {
    margin-top: 120px;
  }
}

.nav-li {
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
}
.figure {
  display: block !important;
}
</style>
